import React, { useEffect, useState } from "react";
import "./Producer.scss";
import ProductFilter from "@containers/ProductFilter/ProductFilter";
import { IProductSearch } from "@utils/Interfaces";
import userApi from "services/UserApi";
import { errorLog } from "logging";
import Helpers from "@utils/Helpers";
import ProducerItem from "@components/ProducerItem/ProducerItem";
import { Empty, Pagination, Skeleton } from "antd";

const Producer: React.FC = () => {
  const [searchParam, setSearchParam] = useState<IProductSearch>({
    query: "",
    type: null,
    location: null,
    selling_method: null,
    categories_id: [1, 2],
    quantity: null,
    radius: 300,
    address: "",
    filters: {
      hay_cut: [],
      bale_weight_min: 0,
      bale_weight_max: 200,
      shape: [],
      size: [],
      hay_compression: [],
      moisture: [],
      rain: [],
      storage: [],
      crop: [],
      binding_type: [],
      price_min: 0,
      price_max: 1000,
      shipping_options: [],
      payment_options: [],
      crude_protein_range_ids: [],
    },
  });
  const [isOpenMap, setIsOpenMap] = useState(false);
  const [allProducers, setAllProducers] = useState<any>(null);
  const [filteredProducers, setFilteredProducers] = useState<any>(null);
  const [isLargeMode, setIsLargeMode] = useState(false);
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [total, setTotal] = useState(0);
  const [pageSizeOptions, setPageSizeOptions] = useState<string[]>([]);

  useEffect(() => {
    const getProducers = async () => {
      try {
        const response = await userApi.getProducers();
        if (response.status === 200) {
          setAllProducers(
            response.data.data.filter(
              (item: any) => item.farm_info.farm_name !== ""
            )
          );
        }
      } catch (error) {
        Helpers.notification.error("Can not fetch producers. Please try again");
        errorLog("Producer.tsx - getProducers", error);
      }
    };
    getProducers();
  }, []);

  const handlePageChange = (page: number, size: number) => {
    setCurrent(page);
    setPageSize(size);
  };

  const handleShowSizeChange = (size: any) => {
    setPageSize(size);
  };

  useEffect(() => {
    if (!allProducers) return;
    const filtered = allProducers.filter((producer: any) => {
      return producer.farm_info.category_ids.some((categoryId: number) =>
        searchParam.categories_id.includes(categoryId)
      );
    });
    setFilteredProducers(filtered);
    setTotal(filtered.length);
  }, [allProducers, searchParam.categories_id]);

  useEffect(() => {
    setCurrent(1);
  }, [searchParam.categories_id]);

  const pagedProducers = filteredProducers
    ? filteredProducers.slice((current - 1) * pageSize, current * pageSize)
    : null;

  useEffect(() => {
    if (total) {
      const maxMultipleOf = Math.ceil(total / 15) * 15;
      const options = [];

      for (let size = 15; size <= maxMultipleOf; size += 15) {
        options.push(size.toString());
      }

      setPageSizeOptions(options);
    }
  }, [total]);

  return (
    <div className="Producer">
      <div className="container mt-4 mb-5">
        <ProductFilter
          searchParam={searchParam}
          setSearchParam={setSearchParam}
          setIsOpenMap={setIsOpenMap}
          isOpenMap={isOpenMap}
          componentIn={"producer"}
          isLargeMode={isLargeMode}
          setIsLargeMode={setIsLargeMode}
        />

        <div className="list-wrap">
          <div className="container">
            {total > 50 && (
              <>
                <div className="section-title-group">
                  <div className="section-title">Top Producers</div>
                  {/* <Link to="/producer/all" className="view-all-btn">
                View All
                </Link> */}
                </div>
                {allProducers == null ? (
                  <div
                    className={`producer-list ${
                      !isLargeMode
                        ? isOpenMap
                          ? "producer-list-3"
                          : "producer-list-5"
                        : isOpenMap
                        ? "producer-list-2"
                        : "producer-list-3"
                    }`}
                  >
                    {Array.from({
                      length: 5,
                    }).map((_, index) => {
                      return (
                        <div className="producer-item" key={index}>
                          <div className="producer-placeholder">
                            <Skeleton.Image
                              active={true}
                              className="skeleton-image"
                            />
                            <div className="content">
                              <Skeleton active={true} />
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    className={`producer-list ${
                      !isLargeMode
                        ? isOpenMap
                          ? "producer-list-3"
                          : "producer-list-5"
                        : isOpenMap
                        ? "producer-list-2"
                        : "producer-list-3"
                    }`}
                  >
                    {(filteredProducers || [])
                      .slice(0, 5)
                      .map((item: any, index: number) => {
                        return <ProducerItem key={index} data={item} />;
                      })}
                  </div>
                )}
              </>
            )}

            <div className="section-title-group">
              <div className="section-title">Producer List</div>
              {/* <Link to="/producer/all" className="view-all-btn">
                View All
                </Link> */}
            </div>
            {allProducers == null ? (
              <div
                className={`producer-list ${
                  !isLargeMode
                    ? isOpenMap
                      ? "producer-list-3"
                      : "producer-list-5"
                    : isOpenMap
                    ? "producer-list-2"
                    : "producer-list-3"
                }`}
              >
                <Skeleton.Image active={true} className="skeleton-image" />
                <div className="content">
                  <Skeleton active={true} />
                </div>
              </div>
            ) : (filteredProducers || []).length === 0 ? (
              <div className="empty-section">
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={"No products found."}
                />
              </div>
            ) : (
              <>
                <div
                  className={`producer-list ${
                    !isLargeMode
                      ? isOpenMap
                        ? "producer-list-3"
                        : "producer-list-5"
                      : isOpenMap
                      ? "producer-list-2"
                      : "producer-list-3"
                  }`}
                >
                   {(pagedProducers || []).map((item: any, index: number) => {
                     return <ProducerItem data={item} key={index} />;
                   })}
                </div>
                <Pagination
                  className="pagination"
                  total={total}
                  showTotal={(total, range) =>
                    `${range[0]}-${range[1]} of ${total} items`
                  }
                  pageSize={pageSize}
                  current={current}
                  align="center"
                  showSizeChanger
                  pageSizeOptions={pageSizeOptions}
                  onShowSizeChange={handleShowSizeChange}
                   onChange={handlePageChange}
                 />
               </>
             )}
          </div>
          {isOpenMap && <div className="producer-map-wrap"></div>}
        </div>
      </div>
    </div>
  );
};

export default Producer;
